import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import o from "../core/Collection.js";
import r from "../core/Error.js";
import { clone as t } from "../core/lang.js";
import { isSome as s } from "../core/maybe.js";
import { property as y } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as l } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as m } from "../core/accessorSupport/decorators/subclass.js";
import { writer as a } from "../core/accessorSupport/decorators/writer.js";
import i from "./ExtrudeSymbol3DLayer.js";
import p from "./FillSymbol3DLayer.js";
import n from "./IconSymbol3DLayer.js";
import b from "./LineSymbol3DLayer.js";
import c from "./ObjectSymbol3DLayer.js";
import f from "./Symbol3D.js";
import u from "./TextSymbol3DLayer.js";
import L from "./WaterSymbol3DLayer.js";

var _S;

var j = o.ofType({
  base: null,
  key: "type",
  typeMap: {
    extrude: i,
    fill: p,
    icon: n,
    line: b,
    object: c,
    text: u,
    water: L
  }
}),
    d = o.ofType({
  base: null,
  key: "type",
  typeMap: {
    extrude: i,
    fill: p,
    icon: n,
    line: b,
    object: c,
    water: L
  }
});

var g = _S = /*#__PURE__*/function (_f) {
  _inherits(S, _f);

  var _super = _createSuper(S);

  function S(e) {
    var _this;

    _classCallCheck(this, S);

    _this = _super.call(this, e), _this.symbolLayers = new j(), _this.type = "polygon-3d";
    return _this;
  }

  _createClass(S, [{
    key: "writeSymbolLayers",
    value: function writeSymbolLayers(e, o, t, s) {
      var y = e.filter(function (e) {
        return "text" !== e.type;
      });

      if (s && s.messages && y.length < e.length) {
        var _o = e.find(function (e) {
          return "text" === e.type;
        });

        s.messages.push(new r("symbol-layer:unsupported", "Symbol layers of type 'text' cannot be persisted in PolygonSymbol3D", {
          symbolLayer: _o
        }));
      }

      o[t] = y.map(function (e) {
        return e.write({}, s);
      }).toArray();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _S({
        styleOrigin: t(this.styleOrigin),
        symbolLayers: t(this.symbolLayers),
        thumbnail: t(this.thumbnail)
      });
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      var o = new _S();

      if (o.read(e), 2 === o.symbolLayers.length && "fill" === o.symbolLayers.getItemAt(0).type && "line" === o.symbolLayers.getItemAt(1).type) {
        var _r = o.symbolLayers.getItemAt(0),
            _t = o.symbolLayers.getItemAt(1);

        !_t.enabled || e.symbolLayers && e.symbolLayers[1] && !1 === e.symbolLayers[1].enable || (_r.outline = {
          size: _t.size,
          color: s(_t.material) ? _t.material.color : null
        }), o.symbolLayers.removeAt(1);
      }

      return o;
    }
  }, {
    key: "fromSimpleFillSymbol",
    value: function fromSimpleFillSymbol(e) {
      return new _S({
        symbolLayers: [p.fromSimpleFillSymbol(e)]
      });
    }
  }]);

  return S;
}(f);

e([y({
  type: j,
  json: {
    type: d
  }
})], g.prototype, "symbolLayers", void 0), e([a("web-scene", "symbolLayers")], g.prototype, "writeSymbolLayers", null), e([l({
  PolygonSymbol3D: "polygon-3d"
}, {
  readOnly: !0
})], g.prototype, "type", void 0), g = _S = e([m("esri.symbols.PolygonSymbol3D")], g);
var h = g;
export { h as default };